import router from '../../Router';

import { postLogin, postLogout } from '../client/login';
import { appLogin, appLogout } from '../../app_hooks';

export const passwordLogin = async (email: string, password: string): Promise<boolean> => {
    const result = await postLogin(email, password);
    await appLogin();
    return result;
};

export const logout = async () => {
    console.log('logging out and clearing session storage.');
    document.dispatchEvent(new Event('logout'));
    await postLogout(router);
    await appLogout();
};
